import { Button, Flex } from "@chakra-ui/react";
import { Card } from "@components/ui-kit";
import { Trans } from "@lingui/macro";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { useScrollToWhen } from "../../hooks";
import { useStore } from "../../store";
import { VatItem } from "./VatItem";

export const VatItems = observer(function VatItems() {
  const store = useStore();
  const { form } = store;

  useEffect(() => {
    if (!store.selectedCurrency) return;
    if (form.expense_vat_items.size === 0) store.createVatItem();
  }, [form.expense_vat_items.size, store.selectedCurrency]);

  const divRef = useScrollToWhen(store.scrollTo.expenseDataCard_vatItems);

  return (
    <Card.Section>
      <div ref={divRef}>
        {Array.from(form.expense_vat_items).map(([idx, i]) => (
          <VatItem key={idx} id={idx} item={i} />
        ))}
        <Flex justify="end" w="full" mt={{ base: "4", md: "unset" }}>
          <Button fontSize="sm" onClick={store.createVatItem} variant="link">
            <Trans>+ Add new VAT rate</Trans>
          </Button>
        </Flex>
      </div>
    </Card.Section>
  );
});
